interface AvatarProps {
  char: string;
  tone: string;
  size?: string;
}

export default function Avatar({ char, tone, size = "w-9 h-9 text-sm" }: AvatarProps) {
  return (
    <span
      className={`${size} ${tone} shrink-0 rounded-full flex items-center justify-center font-bold text-white select-none`}
      aria-hidden="true"
    >
      {char}
    </span>
  );
}